import axios from './Api';

export function ChangeMonth(data: Month.IChangeMonthData = { month: 0, status: 0 }) {
  return axios.post<Settings.ISettingsBlockMonth>(`settings/aidMonthBlock/${data.month}/${data.status}`);
}

export function GetBlockedMonths() {
  return axios.get<boolean[]>('/settings/aidMonthBlocked');
}
